import { render } from "./OrderSupplierTabPurchase.vue?vue&type=template&id=6729f6b8"
import script from "./OrderSupplierTabPurchase.vue?vue&type=script&lang=js"
export * from "./OrderSupplierTabPurchase.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__